'use strict'

import Animations from '../../components/animations_custom'

export default class Processess
{
  constructor()
  {
    this.$elem = $('.Processess')

    if( this.$elem.length > 0 ){
      let self = this

      this.$items = this.$elem.find('.item')
      this.$buttonMore = this.$elem.find('.Processess__buttonMore')
      window.objsAnimations = []

      $(document).ready(function(){
        self.$buttonMore.on('click', function( event ){
          event.preventDefault()
          event.stopPropagation()

          self._actionButton( $(this) )
        })


        $.each(self.$items, function( i,val ){
          Processess._loadResources($(this), function(objAnimation){
            objAnimation.play()
          })
        })
      })

      $(window).resize( ()=> {

      })

      $(window).on("orientationchange", ()=> {

      })

      $( window ).scroll( ()=> {

      })
    }
  }

  static _loadResources( elem, callback )
  {
    elem.append('<div class="_resources"></div>')

    let $container = elem.find('._resources'),
        totalResources = Number(elem.attr('data-steps')),
        baseSrc = elem.find('.item__container__actors').attr('src'),
        resources = [],
        countLoads = 0

    for ( var i = 0; i < ( totalResources - 1 ); i++ )
    {
      var base = baseSrc,
          newSrc = ''

      if( totalResources.toString().length == 2 ){
        if( i < 9 ){
          newSrc = base.replace('00.png', '0'+ ( i + 1 ) +'.png')
        } else{
          newSrc = base.replace('00.png', ( i + 1 ) +'.png')
        }
      } else if( totalResources.toString().length == 3 ){
        if( i < 9 ){
          newSrc = base.replace('000.png', '00'+ ( i + 1 ) +'.png')
        } else if( i < 99){
          newSrc = base.replace('000.png', '0'+ ( i + 1 ) +'.png')
        } else{
          newSrc = base.replace('000.png', ( i + 1 ) +'.png')
        }
      }

      $container.append('<img src="'+ newSrc +'" />')

      resources[i]= new Image()
      resources[i].src = newSrc

      resources[i].onload=function()
      {
        imageLoaded(true)
      }

      resources[i].onerror=function()
      {
        imageLoaded(false)
      }
    }

    function imageLoaded( status, index )
    {
      if( status ){
        countLoads++
        if( countLoads == totalResources - 1 ){

          Processess._createObjAnimation( elem, function( objAnimation ){
            callback( objAnimation )
          })
        }
      }
    }
  }

  static _createObjAnimation( item, callback )
  {
    let options = {
      duration : item.attr('data-duration'),
      steps : item.attr('data-steps'),
      base_url: theme_url + '/images/processes/'+ item.parent().attr('data-process') +'/'+ item.attr('data-module') +'/animation/',
      elem: item.find('.item__container__actors').attr('id'),
      options_tween : {
        delay : 0,
        repeat : -1
      }
    }

    let objAnimation = new Animations.animationBase(options, options.options_tween)
    window.objsAnimations.push(objAnimation)
    callback(objAnimation)
  }

  _actionButton( elem )
  {
    if( elem.hasClass('disabled') ){ return false }

    let paged = parseInt($('#paged').val())+1
    $('#paged').val(paged)

    let taxonomy = $('#taxonomy').val()
    let $container = $('.Processess__container')
    let $loader = $('.loader_theme')
    let $buttonMore = $('.Processess__buttonMore')

    elem.addClass('disabled').hide()

    $loader.addClass('show')
    //Sidebar.resizeContainer()

    if( $('.Sidebar').attr('style') != 'undefined' ){
      $('.Sidebar').removeAttr('style')
    }

    $.ajax({
      method: "POST",
      url: ajaxurl,
      data: { action: "obtener_infografias", paged: parseInt(paged), taxonomy : taxonomy,type : 'loadmore'},
      success: function(response, status, XHR){
        if( response){
          $(response).insertBefore( $loader )

          let $newItem = $container.children('.item').last(),
              idItem = $newItem.find('.item__container__actors').attr('id'),
              load = true,
              objToPlay = {}

          $newItem.hide()
          $buttonMore.hide()

          function validMoreItems(){
            var quantity = $('#quantity').val()
            var paged = $('#paged').val()

            if( quantity > (parseInt(paged)+1) ) {
              $buttonMore.fadeIn('slow', function(){
                $buttonMore.removeClass('disabled')
              })

              $loader.fadeOut('slow', function(){
                $loader.removeClass('show').removeAttr('style')
              })
            } else {
              $loader.fadeOut('slow', function(){
                $loader.removeClass('show').removeAttr('style')
              })
            }
          }

          for( let index_for = 0; index_for < window.objsAnimations.length; index_for++ ){
            let objToAnimate = window.objsAnimations[index_for];

            if( objToAnimate.vars.onUpdateParams[2].id == idItem ){
              load = false
              objToPlay = objToAnimate
            }
          }

          if( load ){
            Processess._loadResources($newItem, function( objAnimation ){
              $newItem.fadeIn('slow', function(){
                objAnimation.play()
                //Sidebar.resizeContainer()
              })

              validMoreItems()
            })
          }
          else{
            //console.log('Ya esta cargado')
            $newItem.fadeIn('slow', function(){
              objToPlay.play()
              //Sidebar.resizeContainer()
            })

            validMoreItems()
          }

          if( $('.Sidebar').attr('style') != 'undefined' ){
            $('.Sidebar').removeAttr('style')
          }
        }
      }
    })
  }
}

